var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBook = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.935,
    height: 20.497,
    viewBox: "0 0 24.935 28.497",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "book-solid",
    d: "M24.935,18.7V2.672A2.672,2.672,0,0,0,22.263,0H5.343A5.343,5.343,0,0,0,0,5.343v17.81A5.343,5.343,0,0,0,5.343,28.5h17.81a1.728,1.728,0,0,0,.891-3.239V20.729A2.832,2.832,0,0,0,24.935,18.7ZM7.965,7.124H18.651a.905.905,0,0,1,.941.891.893.893,0,0,1-.891.891H7.965a.892.892,0,0,1,0-1.781Zm0,3.562H18.651a.905.905,0,0,1,.941.891.893.893,0,0,1-.891.891H7.965a.892.892,0,0,1,0-1.781ZM21.372,24.935H5.343a1.781,1.781,0,1,1,0-3.562H21.372Z",
    fill: "#ffce05"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBook);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/book.89d99d734b2edff85e152d089ecb4f3d.svg";